<template>
  <pnet-validation-observer>
    <div class="container">
      <div class="row" v-for="(rangeValue, index) in rangeValues" v-bind:key="index">
        <div class="col">
          <label for>
            <small>{{labels[0]}}{{index + 1}}</small>
          </label>
          <text-field v-model="rangeValue.from"></text-field>
        </div>
        <div class="col">
          <label v-if="labels[1]" for>
            <small>{{labels[1]}}{{index + 1}}</small>
          </label>
          <text-field v-model="rangeValue.to"></text-field>
        </div>
        <div class="col" v-if="labels[2]">
          <label for>
            <small>{{labels[2]}}{{index + 1}}</small>
          </label>
          <text-field v-model="rangeValue.value"></text-field>
        </div>
      </div>
      <div class="col-12 pt-3 pb-3">
        <div class="filtri mb-4">
          <div class="col-12 col-md-4 col-lg-12" align="right">
            <button class="btn btn-primary mt-4 p-1 pl-3 pr-3" v-on:click.prevent="inserisci">+</button>
            <button
              v-if="rangeValues.length > 1"
              class="btn btn-primary mt-4 p-1 pl-3 pr-3"
              v-on:click.prevent="cancella"
            >-</button>
          </div>
        </div>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import TextField from "@/components/TextField.vue";
export default Vue.extend({
  props: ["value", "labels"],
  components: {
    TextField
  },
  data: function() {
    return {
      rangeValues: [
        {
          order: 0,
          from: "",
          to: "",
          value: ""
        },
      ]
    }},
  methods: {
    inserisci: function() {
      this.rangeValues.push({
        order: this.rangeValues.length,
      });
    },
    cancella: function() {
      this.rangeValues.pop();
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(){
        if (this.value === undefined) {
          this.rangeValues = [{
            order: 0,
            from: "",
            to: "",
            value: ""
          }];
        } else {
          this.rangeValues = this.value;
        }
      }
    },
    rangeValues: {
      deep: true,
      immediate: true,
      handler(){
        this.$emit('input', this.rangeValues);
      }
    }
  },
  mounted() {
    this.rangeValues = this.value;
  },
});
</script>